var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMissionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 21.3334C26.1067 21.3334 21.3334 26.1067 21.3334 32.0001C21.3334 37.8934 26.1067 42.6667 32 42.6667C37.8934 42.6667 42.6667 37.8934 42.6667 32.0001C42.6667 26.1067 37.8934 21.3334 32 21.3334ZM55.84 29.3334C54.6134 18.2134 45.7867 9.38675 34.6667 8.16008V5.33341C34.6667 3.86675 33.4667 2.66675 32 2.66675C30.5334 2.66675 29.3334 3.86675 29.3334 5.33341V8.16008C18.2134 9.38675 9.38669 18.2134 8.16002 29.3334H5.33335C3.86669 29.3334 2.66669 30.5334 2.66669 32.0001C2.66669 33.4667 3.86669 34.6667 5.33335 34.6667H8.16002C9.38669 45.7868 18.2134 54.6134 29.3334 55.8401V58.6667C29.3334 60.1334 30.5334 61.3334 32 61.3334C33.4667 61.3334 34.6667 60.1334 34.6667 58.6667V55.8401C45.7867 54.6134 54.6134 45.7868 55.84 34.6667H58.6667C60.1334 34.6667 61.3334 33.4667 61.3334 32.0001C61.3334 30.5334 60.1334 29.3334 58.6667 29.3334H55.84ZM32 50.6667C21.68 50.6667 13.3334 42.3201 13.3334 32.0001C13.3334 21.6801 21.68 13.3334 32 13.3334C42.32 13.3334 50.6667 21.6801 50.6667 32.0001C50.6667 42.3201 42.32 50.6667 32 50.6667Z",
    fill: "#288344"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMissionIcon);
export default __webpack_public_path__ + "static/media/MissionIcon.3d8cdd861f4d7539690d653f01ae658d.svg";
export { ForwardRef as ReactComponent };